// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file contact.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file contact.proto.
 */
export const file_contact: GenFile = /*@__PURE__*/
  fileDesc("Cg1jb250YWN0LnByb3RvEgtncnBjLmFwaS52MSKbAwoHQ29udGFjdBIKCgJpZBgBIAEoAxIMCgRuYW1lGAIgASgJEg0KBXBob25lGAMgASgJEg0KBWVtYWlsGAQgASgJEg8KB2FkZHJlc3MYBSABKAkSEgoKcG9zdGFsQ29kZRgGIAEoCRIMCgRjaXR5GAcgASgJEg0KBXN0YXRlGAggASgJEg8KB2NvdW50cnkYCSABKAkSEwoLY29tcGFueU5hbWUYCiABKAkSGAoQcmVzZXJ2YXRpb25Db3VudBgLIAEoBRINCgVpc1ZJUBgMIAEoCBIZChFwcmVmZXJyZWRMYW5ndWFnZRgNIAEoCRIQCghiaXJ0aGRheRgOIAEoBRIeChZuZXdzbGV0dGVyU3Vic2NyaXB0aW9uGA8gASgIEg0KBW5vdGVzGBAgASgJEg0KBXRpdGxlGBEgASgJEhIKCnZpc2l0Q291bnQYEiABKAUSEQoJbGFzdFZpc2l0GBMgASgDEhEKCWlzRGVsZXRlZBgUIAEoCBIQCghkdENyZWF0ZRgVIAEoAxIQCghkdFVwZGF0ZRgWIAEoAyqfAQoMQ29udGFjdFRpdGxlEh0KGUNPTlRBQ1RfVElUTEVfVU5TUEVDSUZJRUQQABIUChBDT05UQUNUX1RJVExFX01SEAESFAoQQ09OVEFDVF9USVRMRV9NUxACEhUKEUNPTlRBQ1RfVElUTEVfTVJTEAMSFgoSQ09OVEFDVF9USVRMRV9NSVNTEAQSFQoRQ09OVEFDVF9USVRMRV9GQU0QBUIGWgQuO3BiYgZwcm90bzM");

/**
 * Contact
 *
 * @generated from message grpc.api.v1.Contact
 */
export type Contact = Message<"grpc.api.v1.Contact"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string phone = 3;
   */
  phone: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * @generated from field: string address = 5;
   */
  address: string;

  /**
   * @generated from field: string postalCode = 6;
   */
  postalCode: string;

  /**
   * @generated from field: string city = 7;
   */
  city: string;

  /**
   * @generated from field: string state = 8;
   */
  state: string;

  /**
   * @generated from field: string country = 9;
   */
  country: string;

  /**
   * @generated from field: string companyName = 10;
   */
  companyName: string;

  /**
   * @generated from field: int32 reservationCount = 11;
   */
  reservationCount: number;

  /**
   * @generated from field: bool isVIP = 12;
   */
  isVIP: boolean;

  /**
   * @generated from field: string preferredLanguage = 13;
   */
  preferredLanguage: string;

  /**
   * @generated from field: int32 birthday = 14;
   */
  birthday: number;

  /**
   * @generated from field: bool newsletterSubscription = 15;
   */
  newsletterSubscription: boolean;

  /**
   * @generated from field: string notes = 16;
   */
  notes: string;

  /**
   * @generated from field: string title = 17;
   */
  title: string;

  /**
   * @generated from field: int32 visitCount = 18;
   */
  visitCount: number;

  /**
   * @generated from field: int64 lastVisit = 19;
   */
  lastVisit: bigint;

  /**
   * @generated from field: bool isDeleted = 20;
   */
  isDeleted: boolean;

  /**
   * @generated from field: int64 dtCreate = 21;
   */
  dtCreate: bigint;

  /**
   * @generated from field: int64 dtUpdate = 22;
   */
  dtUpdate: bigint;
};

/**
 * Describes the message grpc.api.v1.Contact.
 * Use `create(ContactSchema)` to create a new message.
 */
export const ContactSchema: GenMessage<Contact> = /*@__PURE__*/
  messageDesc(file_contact, 0);

/**
 * ContactTitle
 *
 * @generated from enum grpc.api.v1.ContactTitle
 */
export enum ContactTitle {
  /**
   * @generated from enum value: CONTACT_TITLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONTACT_TITLE_MR = 1;
   */
  MR = 1,

  /**
   * @generated from enum value: CONTACT_TITLE_MS = 2;
   */
  MS = 2,

  /**
   * @generated from enum value: CONTACT_TITLE_MRS = 3;
   */
  MRS = 3,

  /**
   * @generated from enum value: CONTACT_TITLE_MISS = 4;
   */
  MISS = 4,

  /**
   * @generated from enum value: CONTACT_TITLE_FAM = 5;
   */
  FAM = 5,
}

/**
 * Describes the enum grpc.api.v1.ContactTitle.
 */
export const ContactTitleSchema: GenEnum<ContactTitle> = /*@__PURE__*/
  enumDesc(file_contact, 0);

